import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=5472afad&"
import script from "./Timer.vue?vue&type=script&lang=ts&"
export * from "./Timer.vue?vue&type=script&lang=ts&"
import style0 from "./Timer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports